import Api from '@/services/Index';
import FinanceApi from '@/services/FinanceApi';

const getAll = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_FINANCE;
    return Api.get('/pilotage/payment/details', config);
}

const get = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_FINANCE;
    return Api.get('/pilotage/payment/details/' + id);
}

const store = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_FINANCE;
    return Api.post('/pilotage/payment/details', data);
}

const update = async (id, formData, config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_FINANCE;
    return Api.post('/pilotage/payment/details/' +  id, formData, config);
}

const del = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_FINANCE;
    return Api.delete('/pilotage/payment/details/' + id);
}

const download = async (id) => {
    // Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return FinanceApi.get('/pilotage/payment/details/' + id + '/download', {responseType: "arraybuffer"});
}

export default {
    getAll,
    get,
    update,
    store,
    download,
    del
}
